import { gql } from "@apollo/client"; // saveVisitaNpidNutricionista.js


const SAVE_VISITA_NPID_NUTRICIONISTA = gql`
  mutation saveVisitaNpidNutricionista($input: AddVisitaNpidNutricionistaInput!) {
    saveVisitaNpidNutricionista(input: $input) {
      idVisita
      idVisitaNpid
    }
  }
`;

export default SAVE_VISITA_NPID_NUTRICIONISTA;

export const adaptAddVisitaNpidNutricionistaInput = (data) => ({
  idVisitaNpid: data?.idVisitaNpid,
  ingestaOral: !!data?.ingestaOral,
  suplementoOral: !!data?.suplementoOral,
  requerimientoCalorico: data?.requerimientoCalorico,
  dietaConvencional: data?.dietaConvencional,
  complicaciones: data?.complicaciones,
  idVisita: data?.idVisita
});